module.exports = "https://health.dajiuxing.com.cn/img/assets/img/grant_close.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fgrant_close.png
// module id = JfGQ
// module chunks = 93